import { produce } from 'immer';

import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_FIELD_POSITION_CHANGE,
  CONTRACT_PROGRESS_FIELD_POSITION_INITIALIZE,
  CONTRACT_PROGRESS_SIGNATURE_INSERTION_RESET,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';
import FieldPosition from '@app/store/contract-progress/FieldPosition';

export interface ContractProgressFieldPositionsState {
  [id: string]: FieldPosition;
}

const initialState: ContractProgressFieldPositionsState = {};

export default function reducer(
  state: ContractProgressFieldPositionsState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    case CONTRACT_PROGRESS_FIELD_POSITION_CHANGE:
      return produce(state, (draft) => {
        const {
          id,
          currentRelativeOffsetX,
          currentRelativeOffsetY,
          currentRelativePageX,
          currentRelativePageY,
        } = action.payload;

        draft[id].currentRelativeOffsetX = currentRelativeOffsetX;
        draft[id].currentRelativeOffsetY = currentRelativeOffsetY;
        draft[id].currentRelativePageX = currentRelativePageX;
        draft[id].currentRelativePageY = currentRelativePageY;
      });
    case CONTRACT_PROGRESS_FIELD_POSITION_INITIALIZE:
      return produce(state, (draft) => {
        const { id, relativePageX, relativePageY } = action.payload;
        draft[id].currentRelativePageX = relativePageX;
        draft[id].currentRelativePageY = relativePageY;
        draft[id].initialRelativePageX = relativePageX;
        draft[id].initialRelativePageY = relativePageY;
      });
    case CONTRACT_PROGRESS_SIGNATURE_INSERTION_RESET:
      return produce(state, (draft) => {
        Object.entries(draft).forEach(([key, value]) => {
          draft[key].currentRelativeOffsetX = value.initialRelativeOffsetX;
          draft[key].currentRelativeOffsetY = value.initialRelativeOffsetY;
          draft[key].currentRelativePageX = value.initialRelativePageX;
          draft[key].currentRelativePageY = value.initialRelativePageY;
        });
      });
    default:
      return state;
  }
}
